import { StyledRange } from 'components/DatePickerStyles/DatePickerStyles'
import CalendarIcon from 'components/icons/CalendarIcon'
import SeperatorIcon from 'components/icons/SeperatorIcon'
import React from 'react'

const BatchFilter = ({ setBatchFilter }) => {
  const onBatchChange = (value, years) => {
    setBatchFilter({ startBatch: years[0], endBatch: years[1] })
  }

  return (
    <StyledRange
      width="70%"
      picker="year"
      placeholder={['YYYY', 'YYYY']}
      separator={<SeperatorIcon />}
      suffixIcon={<CalendarIcon />}
      onChange={onBatchChange}
      allowClear={true}
    />
  )
}

export default BatchFilter
